import { HTMLAttributes, PropsWithChildren } from "react";
import styled, { css } from "styled-components";
import { ColorToken } from "../../styles/tokens";

// TEXT

// CONSTANTS
export const NORMAL_LINE_HEIGHT = 1.5; // in rem

// STYLES
export const normalStyles = css`
  font-weight: 500;
  font-size: 1rem;
  line-height: ${NORMAL_LINE_HEIGHT}rem;
  letter-spacing: 0.06em;
`;

export const normalStrongStyles = css`
  font-weight: 600;
  font-size: 1rem;
  line-height: ${NORMAL_LINE_HEIGHT}rem;
  letter-spacing: 0.06em;
`;

export const Normal = styled.p<BodyProps>`
  ${normalStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
  strong {
    ${normalStrongStyles};
  }
`;

export const NormalStrong = styled.p<BodyProps>`
  ${normalStrongStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
`;

export const smallStyles = css`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: ${NORMAL_LINE_HEIGHT}rem;
  letter-spacing: 0.06em;
`;

export const smallStrongStyles = css`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: ${NORMAL_LINE_HEIGHT}rem;
  letter-spacing: 0.06em;
`;

export const Small = styled.small<BodyProps>`
  ${smallStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
  strong {
    ${smallStrongStyles};
  }
`;

export const SmallStrong = styled.small<BodyProps>`
  ${smallStrongStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
`;

export const xSmallStyles = css`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1.25rem;
  letter-spacing: 0.06em;
`;

export const xsmallStrongStyles = css`
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1.25rem;
  letter-spacing: 0.06em;
`;

export const XSmall = styled.small<BodyProps>`
  ${xSmallStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
  strong {
    ${xsmallStrongStyles};
  }
`;

export const XSmallStrong = styled.small<BodyProps>`
  ${xsmallStrongStyles};
  ${({ $color }) =>
    $color &&
    css`
      color: ${$color};
    `}
`;

// DATA

// TYPES
export interface Props extends PropsWithChildren, HTMLAttributes<HTMLElement> {
  variant?: variant;
  tag?: "div" | "span" | "p" | "small";
  /**
   * The `string & {}` intersection type enables autocomplete for ColorToken values
   * while still accepting any string. TypeScript treats `ColorToken | (string & {})`
   * differently than `ColorToken | string` for autocomplete purposes.
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  color?: ColorToken | (string & {}); //i.e. "primary01" or "#ff0000" or {shade500}
}

type BodyProps = HTMLAttributes<HTMLElement> & {
  $color?: string;
};

export type variant =
  | "normal"
  | "normal-strong"
  | "small"
  | "small-strong"
  | "xsmall"
  | "xsmall-strong";

// FUNCTIONS

// ASSETS
